import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  createDelegation,
  fetchDelegations,
} from "../../../../redux/slices/delegationSlice";
import { fetchUsers } from "../../../../redux/slices/userSlice";
import EditDelegationContent from "../EditDelegationModal/EditDelegationModal";

const CreateDelegationModal = ({ onClose, onCreated }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleSave = async ({ name, location, description, members }) => {
    const trimmedName = name.trim();
    if (!trimmedName) return;

    await dispatch(
      createDelegation({
        name: trimmedName,
        location,
        description,
        members: members.map((member) => member.user_id || member.id),
      }),
    ).unwrap();

    await dispatch(fetchDelegations());
    await dispatch(fetchUsers());

    if (onCreated) {
      onCreated();
    }
    onClose();
  };

  return (
    <EditDelegationContent
      mode="create"
      initialName=""
      initialLocation=""
      initialDescription=""
      initialMembers={[]}
      onSave={handleSave}
      onCancel={onClose}
    />
  );
};

export default CreateDelegationModal;
